import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { HERO_IMAGE } from "@/lib/api";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-end pb-20 md:pb-32 lk-grain"
    >
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt="Luxury event" className="w-full h-full object-cover scale-105" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/60 to-[#050505]" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-24 grid md:grid-cols-12 gap-8 items-end">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="md:col-span-8"
        >
          <div className="flex items-center gap-3 mb-6 text-[#D4AF37]">
            <Sparkles className="w-4 h-4" />
            <span className="text-xs tracking-[0.35em] uppercase">Luxury Kingz LLC</span>
          </div>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tight">
            Capture the
            <br />
            <span className="italic gold-gradient-text">unforgettable.</span>
          </h1>
          <p className="mt-8 max-w-xl text-zinc-300 text-base md:text-lg leading-relaxed">
            Premium Photo Booth & 360° experiences crafted for weddings, galas,
            and milestone celebrations. Starting at <span className="text-[#D4AF37]">$350</span>.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/book" data-testid="hero-book-now" className="lk-btn-primary text-xs inline-flex items-center justify-center gap-3 group">
              Reserve Your Date
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a href="#services" data-testid="hero-explore" className="lk-btn-secondary text-xs text-center">
              Explore Services
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, delay: 0.6 }}
          className="md:col-span-4 hidden md:block"
        >
          <div className="border-l border-[#D4AF37]/30 pl-6 space-y-6">
            <div>
              <div className="text-3xl font-serif gold-gradient-text">350+</div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Events Captured</div>
            </div>
            <div>
              <div className="text-3xl font-serif gold-gradient-text">4hrs</div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Minimum Booking</div>
            </div>
            <div>
              <div className="text-3xl font-serif gold-gradient-text">∞</div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Memories Made</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
